import { render } from "./BrandedHeader.vue?vue&type=template&id=7f146017&scoped=true"
import script from "./BrandedHeader.vue?vue&type=script&lang=js"
export * from "./BrandedHeader.vue?vue&type=script&lang=js"

import "./BrandedHeader.vue?vue&type=style&index=0&id=7f146017&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f146017"]])

export default __exports__